import React from 'react';

const Wrapper = ({ children }) => (
  <div className='detail-wrapper'>
    {children}
  </div>
)

export default Wrapper;
